// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// コンポーネントのインポート
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './sections/Hero';
import Mission from './sections/Mission';
import Service from './sections/Service';
import Store from './sections/Store';
import Company from './sections/Company';
import Media from './sections/Media';

import './styles/index.css';

function App() {  
  return (
    <Router>
      <div className="app-container">
        <main className="main-content">
          <Hero />
          <Mission /> 
          <Service />
          <Store />
          <Company />
          <Media />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;